import { createSelector, OutputSelector } from 'reselect';
import { Context } from 'configuration-schemas/confdefn';
import { AppState } from 'src/store';
import { getActiveContext } from '../PerspectiveSelection/PerspectiveSelection.selectors';
import { isNil } from 'lodash';

interface FiltersEnabledSelector
  extends OutputSelector<
    AppState,
    boolean,
    (context: Context, headerbarType: 'AssortmentHeaderbar' | 'MfpHeaderbar') => boolean
  > {}

const getPerspectiveHeaderbarType = (state: AppState) => {
  return state.appConfig.tenantConfig.perspective?.headerbar.type;
};

export const getFiltersEnabled: FiltersEnabledSelector = createSelector(
  [getActiveContext, getPerspectiveHeaderbarType],
  (activeContext, headerbarType) => {
    let isEnabled = true;
    const filtersDisabledInContext = activeContext?.filters?.disabled;

    if (headerbarType === 'MfpHeaderbar' || filtersDisabledInContext || isNil(activeContext)) {
      isEnabled = false;
    }

    return isEnabled;
  },
);
